import React from "react";

const BS5_FloatingLabels = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_FloatingLabels Component</h2>
      <p>This is the BS5_FloatingLabels component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_FloatingLabels;
